import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

import {AppConfig} from '../app.config';
import {RoleModel, UserModel} from '../models/user';
import {APIResponse} from 'app/models/response';



@Injectable()
export class UserService {
  endpoint = '';

  constructor(private http: HttpClient, private config: AppConfig) {
    this.endpoint = config.getConfig('api_endpoint');
  }

  getAll(): Observable<UserModel[]> {
    return this.http.post<APIResponse>(this.endpoint, {method: 'users.list'})
      .map(response => {
        const users: Array<UserModel> = [];
        if (response && response.api_status == 0) {
          response.data.map( user => users.push(UserModel.create( user )) );
        }
        return users;
      });
  }

  getById(id: number): Observable<UserModel> {
    return this.http.post<APIResponse>(this.endpoint, { method: 'users.get', params: { _id: id } })
      .map( response => {
        if (response && response.api_status == 0) {
          return UserModel.create(response.data);
        }
    });
  }

  create(user: UserModel) {
    return this.http.post<APIResponse>(this.endpoint, {method: 'users.create', params: user });
  }

  update(user: UserModel) {
    return this.http.post<APIResponse>(this.endpoint, {method: 'users.update', params: user });
  }

  remove(id: number) {
    return this.http.post<APIResponse>(this.endpoint, {method: 'users.delete', params: { _id: id } });
  }

  getRoles(): Observable<RoleModel[]> {
    return this.http.post<APIResponse>(this.endpoint, {method: 'roles.list'})
      .map(response => {
        const roles: Array<RoleModel> = [];
        if (response && response.api_status == 0) {
          response.data.map( role => roles.push(role) );
        }
        return roles;
      });
  }

  getRoleItems( role_id ) {
    return this.http.post<APIResponse>(this.endpoint, {method: 'roles.items', params: { ROLE_ID: role_id}})
      .map(response => {
        const items: Array<any> = [];
        if (response && response.api_status == 0) {
          response.data.map( item => items.push(item) );
        }
        return items;
      });
  }

  saveRoleItems( role_id, items ) {
    return this.http.post<APIResponse>(this.endpoint, {method: 'roles.items.update', params: { ROLE_ID: role_id, ITEMS: items}});
  }

}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/services/user.service.ts